"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TableHead = exports.TableCell = exports.TableRow = exports.Table = void 0;

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var Table = exports.Table = function (a) {
  return _react2.default.createElement("div", {
    style: {
      overflowX: "auto"
    }
  }, _react2.default.createElement("div", (0, _extends3.default)({}, a, {
    style: (0, _extends3.default)({}, "style" in a ? a.style : {}, {
      display: "table"
    })
  })));
},
    TableRow = exports.TableRow = function (a) {
  return _react2.default.createElement("div", (0, _extends3.default)({}, a, {
    style: (0, _extends3.default)({}, "style" in a ? a.style : {}, {
      display: "table-row"
    })
  }));
},
    TableCell = exports.TableCell = function (a) {
  return _react2.default.createElement("div", (0, _extends3.default)({}, a, {
    style: (0, _extends3.default)({}, "style" in a ? a.style : {}, {
      display: "table-cell",
      border: "1px solid #eee",
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 4,
      paddingBottom: 4
    })
  }));
},
    TableHead = exports.TableHead = function (a) {
  return _react2.default.createElement("div", (0, _extends3.default)({}, a, {
    style: (0, _extends3.default)({}, "style" in a ? a.style : {}, {
      display: "table-cell",
      border: "1px solid #eee",
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 4,
      paddingBottom: 4,
      fontWeight: 700
    })
  }));
};